$(document).ready(function(){
  function view_button() {
   setTimeout(function() {
      $(".cart-drawer__content .for-scrl-div .cart-item-upsells .product-block .product-info").each(function() {
        var product_link = $(this).find(".product-link").attr("href");
        if ($(this).parent().find(".view_button").length === 0) {
          $(this).after(`<div class="view_button"><a href="${product_link}"> View product</a></div>`);
        }
      });
    }, 1000); 
  }

  $(document).on("theme:open-cart-drawer", function() {
    view_button();
    setTimeout(function(){
      view_button();
    }, 1000);
  });
  
  $(document).on("theme:cartchanged", function() {
    view_button();
    setTimeout(function(){
      view_button();
    }, 1000);
  });


  // Legacy in-popup login form removed — New Customer Accounts
  // CTAs use New Customer Accounts: https://shopify.com/{shop_id}/account
  
});

// Timed member offer popup — guests only
(function () {
  var memberClub = document.querySelector(".cart-member-club");
  if (!memberClub || memberClub.getAttribute("data-customer-logged-in") === "true") return;
  if (sessionStorage.getItem("popupShown")) return;

  setTimeout(function () {
    if (sessionStorage.getItem("popupShown")) return;
    memberClub.classList.add("active");
    document.body.classList.add("popup-open");
    var header = document.querySelector('[data-section-type="header"]');
    if (header) header.classList.add("hidden-visibility");
    sessionStorage.setItem("popupShown", "true");
  }, 30000);
})();
